exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".configurator[data-v-6b5c7b4e]{margin-left:15px}.card-header.bg-dark[data-v-6b5c7b4e]{background-color:#eaedef!important;color:#000!important}@media screen and (max-width:768px){.card[data-v-6b5c7b4e]{margin-left:5px!important;width:185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b5c7b4e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/configurators/config-user.vue
// module id = 1637
// module chunks = 0